<template>
    <div id="SMFHosting">
        <div class="container">
            <h1 class="text-primary">{{ $t('hosting')}}</h1>
            <webRequest :url="getUrl" :key="componentKey" ident="productHosting"></webRequest>
            <!-- <p>language: {{ this.$i18n.locale }}</p> -->
        </div>
    </div>
</template>

<script>
    import webRequest from '@/components/web-request.vue'

    export default {
        name: 'Hosting',
        components: {
            webRequest
        },
        data() {
            return {
                data: 'loading...',
                componentKey: 0
            }
        },
        methods: {
            refreshComponent() {
                this.componentKey += 1
            }
        },
        computed: {
            getUrl() {
                return '/hosting-' + this.$i18n.locale + '.html'
            }
        }
    }
</script>

<style scoped lang="css">
    figure {
        margin: 2%;
    }

    aside {
        float: right;
        width: 20%;
        text-align: center;
    }

    .docscript-img {
        max-width: 95%;
        border: 2px solid #777;
    }

        .docscript-img:hover {
            box-shadow: 0 0 10px #ccc;
        }

    .docscript-footnote {
        margin-bottom: 0rem;
    }

    #SMFHosting {
        background: rgb(220,226,226);
    }
</style>
